import ConfirmEmailAdvancedView from './ConfirmEmailAdvancedView'
export default ConfirmEmailAdvancedView
